<template>
    <div id="goods-select-visible">
        <el-dialog :title="$STR('CODE.goodsSelectVisible.title', '选择商品')" :visible.sync="dialogVisible"  @close="closeDialog" :close-on-click-modal="false" class="dialog-large">
            <div style="margin-bottom: 10px;width:100%">
                <el-select clearable v-model="selectId" :placeholder="$STR('pd_label_production_plan_production_cate_select', '选择目录')">
                    <el-option
                        v-for="item in selectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-input clearable :placeholder="$STR('pd_label_input_production_plan_production_enter_goods_name_or_goods_code', '输入商品名称/商品编号')" v-model="keyword" @keyup.enter.native="getGoodsSkuList"></el-input>
                <el-button type="primary" plain @click="getGoodsList({current: 1, rows: 20})">{{ $STR('COMMON.common.search', '查询') }}</el-button>
                <!-- <el-button @click="resetData" style="margin-left: 30px">{{ $STR('ORDER.goodsSelect.reset', '重置') }}</el-button> -->
            </div>
            <el-table ref="multipleTable" :empty-text="$STR('COMMON.data.empty', '暂无数据')" :data="goodsTable.list" style="width: 100%" highlight-current-row @selection-change="handleSelectionChange" class="good-list">  <!--@expand-change="getSkuList"-->
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <!--<el-table-column
                        :lable="$STR('COMMON.common.btn.choose', '选择')" width="60">
                    <template slot-scope="scope">
                        <el-radio v-model="goodsRadio" :label="scope.row" @change="selectGoods">{{defaultData}}</el-radio>
                    </template>
                </el-table-column>
                <el-table-column type="expand">
                    <template slot-scope="scope">
                        <el-checkbox-group v-model="checkList">
                            <el-checkbox :label="check" v-for="(check,index) of scope.row.skuInfo" :key="index">{{check.skuName}}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-table-column>-->
                <el-table-column
                    label="编码" :show-overflow-tooltip="true" prop="code">
                </el-table-column>
                <el-table-column
                    label="商品信息" :show-overflow-tooltip="true" style="max-width: 300px">
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                        <!--<div class="el-text-overflow goods-info">
                            <p>
                                <span style="font-size: 16px;font-weight: 600;color: #333333">{{scope.row.name}}</span>
                            </p>
                            <p><span>单位:</span><span>{{scope.row.unit}}</span></p>
                            <p><span>备注:</span><span>{{scope.row.remarks}}</span></p>
                    </div>-->
                    </template>
                </el-table-column>
                <el-table-column
                    :label="this.$STR('goods.addGoods.category', '归属目录')" :show-overflow-tooltip="true" prop="categoryName">
                </el-table-column>
                <el-table-column
                    :label="this.$STR('goods.goodsManager.table.brand', '所属品牌')" :show-overflow-tooltip="true" prop="brandName">
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="current"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="goodsTable.count">
            </el-pagination>
            <div class="oper-button">
                <el-button type="" @click="closeDialog">
                    {{$STR('COMMON.common.btn.cancel', '取消')}}
                </el-button>
                <el-button type="primary" plain @click="submitGoods" v-duplication>
                    {{$STR('COMMON.common.btn.confirm', '确定')}}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ['visible', 'goodsList', 'userSelectData', 'brandId'],
    data () {
        return {
            templateSelection: [],
            dialogVisible: false,
            current: 1,
            rows: 20,
            goodsRadio: '',
            defaultData: '',
            checkList: [],
            goodsTable: {
                list: [],
                count: 0
            },
            keyword: '',
            //品牌
            goodsBrandList: [],
            //目录
            selectId: '',
            selectList: []
        };
    },
    components: {
    },
    created() {
        this.getGoodsList({current: 1, rows: 20});
        this.getGoodsBrandList();
        this.getCategoryList();
    },
    activated () {
    },
    watch: {
        visible() {
            this.goodsTable = this.goodsList;
            this.dialogVisible = this.visible;
            this.resetData();
        },
        userSelectData() {
            /*this.checkList = [];
                this.goodsRadio = '';*/
        },
        brandId (val) {
            this.getCategoryList();
        }
    },
    filters: {
    },
    methods: {
        singleElection() {
            console.log(this.templateSelection);
        },
        selectGoods() {
            console.log(this.goodsRadio);
        },
        resetData() {
            this.selectId = '';
            this.keyword = '';
            this.getGoodsList({current: 1, rows: 20});
        },
        getSkuList(row, expandedRows, expanded) {
            let _self = this;
            if (row.skuInfo !== undefined) {
                return;
            }
            _self.$http.get(WebApi.goods.skuList + '/' + row.id).then(response => {
                row.skuInfo = [];
                for (let sku of response.data.data) {
                    let skuInfo = {};
                    skuInfo.skuId = sku.id;
                    skuInfo.skuCode = sku.code;
                    let str = row.name + '-';
                    for (let item of sku.skuAttrList.list) {
                        str += item.optionValue;
                    }
                    skuInfo.skuName = str;
                    row.skuInfo.push(skuInfo);
                }
            });
        },
        handleSizeChange(val) {
            let data = {};
            this.rows = val;
            data.rows = this.rows;
            data.current = this.current;
            this.getGoodsList(data);
        },
        handleCurrentChange(val) {
            let data = {};
            this.current = val;
            data.rows = this.rows;
            data.current = this.current;
            this.getGoodsList(data);
        },
        closeDialog() {
            this.dialogVisible = false;
            this.$emit('close');
        },
        getGoodsList(data) {
            this.current = data.current || 1;
            this.rows = data.rows || 20;
            this.$emit('getGoodsList', {current: data.current, rows: data.rows, order: 'createDate', asc: false, categoryId: this.selectId, keyword: this.keyword});
        },
        handleSelectionChange(val) {
            this.templateSelection = val;
        },
        submitGoods() {
            if (this.templateSelection.length === 0) {
                this.$message({
                    showClose: true,
                    message: this.$STR('CODE.qccCodeApply.error.inputGoods', '请选择商品'),
                    type: 'error'
                });
                return;
            }
            this.closeDialog();
            this.$emit('submitGoods', {templateSelection: this.templateSelection, userSelectData: this.userSelectData} );
        },
        //获取品牌列表
        getGoodsBrandList() {
            var _self = this;
            _self.$http.get(WebApi.warehouse.goodsBrand, {
                params: {
                }
            }).then(_ => {
                _self.goodsBrandList = _.data.data;
            });
        },
        //获取工厂
        getFactoryList() {
            let _self = this;
            _self.$http.get(WebApi.production.getFactory).then(response => {
                _self.factoryList = response.data.data;
            });
        },
        /** 获取目录列表 */
        getCategoryList() {
            let _self = this;
            _self.$http.get(WebApi.goods.goodsCategory + '?brandId=' + (this.brandId || '')).then(response => {
                let _list = [];
                response.data.data.forEach(v => {
                    _list.push({'id': v.id, 'name': v.name});
                });
                _self.selectList = _list;
            });
        },
        // 回显选中
        goodsSelectionList(list) {
            this.goodsTable.list.forEach((row, index) => {
                list.forEach(data => {
                    if (row.id === data.id) {
                        this.$nextTick(() => {
                            this.$refs.multipleTable.toggleRowSelection(this.$refs.multipleTable.data[index], true);
                        });
                    }
                });
            });
            this.templateSelection = list;
        }
    }
};
</script>
<style scoped>
    .good-list{
        height: 100%;
        overflow-y: auto;
    }
    .oper-button{
        padding-top: 10px;
    }
</style>
<style>
    #goods-select-visible .good-list .el-checkbox-group{
        display: flex;
        flex-direction: column;
        margin-left: 30px;
    }
    #goods-select-visible .good-list .el-checkbox-group .el-checkbox{
        padding: 5px 0px;
    }
    #goods-select-visible .el-table:before{
        background-color: transparent;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/warehouse/goodsSelect.vue